
import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-16 bg-tech-dark text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-accent/20 via-tech-dark to-tech-dark"></div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,_#8b5cf610_1px,_transparent_1px),_linear-gradient(to_bottom,_#8b5cf610_1px,_transparent_1px)] bg-[size:20px_20px]"></div>
      
      <div className="container mx-auto relative z-10 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your Technology Infrastructure?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Join 2000+ satisfied clients who trust Truecore Gadget Innovations for their custom hardware needs.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 justify-center">
            <a href="#contact" className="tech-btn-primary">
              Get a Free Quote
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
            <a href="#products" className="tech-btn-outline">
              Explore Our Products
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
